/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Attachment', 'model/Conference', 'model/DataResponse', 'model/ErrorResponse', 'model/Lecturer', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Presentation', 'model/PresentationsurveyquestionOptions', 'model/Question', 'model/QuestionOptions', 'model/Sponsor', 'model/SuccessResponse', 'api/DefaultApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/Attachment'), require('./model/Conference'), require('./model/DataResponse'), require('./model/ErrorResponse'), require('./model/Lecturer'), require('./model/Params'), require('./model/Params1'), require('./model/Params2'), require('./model/Params3'), require('./model/Presentation'), require('./model/PresentationsurveyquestionOptions'), require('./model/Question'), require('./model/QuestionOptions'), require('./model/Sponsor'), require('./model/SuccessResponse'), require('./api/DefaultApi'));
  }
}(function(ApiClient, Attachment, Conference, DataResponse, ErrorResponse, Lecturer, Params, Params1, Params2, Params3, Presentation, PresentationsurveyquestionOptions, Question, QuestionOptions, Sponsor, SuccessResponse, DefaultApi) {
  'use strict';

  /**
   * ERROR_UNKNOWN.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var ConferenceBackend = require('index'); // See note below*.
   * var xxxSvc = new ConferenceBackend.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new ConferenceBackend.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new ConferenceBackend.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new ConferenceBackend.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 0.0.1
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The Attachment model constructor.
     * @property {module:model/Attachment}
     */
    Attachment: Attachment,
    /**
     * The Conference model constructor.
     * @property {module:model/Conference}
     */
    Conference: Conference,
    /**
     * The DataResponse model constructor.
     * @property {module:model/DataResponse}
     */
    DataResponse: DataResponse,
    /**
     * The ErrorResponse model constructor.
     * @property {module:model/ErrorResponse}
     */
    ErrorResponse: ErrorResponse,
    /**
     * The Lecturer model constructor.
     * @property {module:model/Lecturer}
     */
    Lecturer: Lecturer,
    /**
     * The Params model constructor.
     * @property {module:model/Params}
     */
    Params: Params,
    /**
     * The Params1 model constructor.
     * @property {module:model/Params1}
     */
    Params1: Params1,
    /**
     * The Params2 model constructor.
     * @property {module:model/Params2}
     */
    Params2: Params2,
    /**
     * The Params3 model constructor.
     * @property {module:model/Params3}
     */
    Params3: Params3,
    /**
     * The Presentation model constructor.
     * @property {module:model/Presentation}
     */
    Presentation: Presentation,
    /**
     * The PresentationsurveyquestionOptions model constructor.
     * @property {module:model/PresentationsurveyquestionOptions}
     */
    PresentationsurveyquestionOptions: PresentationsurveyquestionOptions,
    /**
     * The Question model constructor.
     * @property {module:model/Question}
     */
    Question: Question,
    /**
     * The QuestionOptions model constructor.
     * @property {module:model/QuestionOptions}
     */
    QuestionOptions: QuestionOptions,
    /**
     * The Sponsor model constructor.
     * @property {module:model/Sponsor}
     */
    Sponsor: Sponsor,
    /**
     * The SuccessResponse model constructor.
     * @property {module:model/SuccessResponse}
     */
    SuccessResponse: SuccessResponse,
    /**
     * The DefaultApi service constructor.
     * @property {module:api/DefaultApi}
     */
    DefaultApi: DefaultApi
  };

  return exports;
}));




// WEBPACK FOOTER //
// ./generated/src/index.js